import React from 'react';
import { getEmojiDiagramGrid } from '../../utils/diagramEditor';

/**
 * Renders an emoji (picture-chart) diagram: `diagram.labels` is a 2D grid of
 * cells (or a flat list for a single row), e.g.
 *   [["Cars:", "⭐", "⭐"], ["Dolls:", "⭐"]]
 */
const EmojiDiagramView = ({ diagram, className = '' }) => {
  const grid = getEmojiDiagramGrid(diagram);
  if (grid.length === 0) return null;

  const fontSizePt = Number(diagram?.font_size_pt) || 12;
  const cellFontSize = `${Math.max(fontSizePt * 1.6, 16)}px`;

  return (
    <div className={`overflow-x-auto ${className}`}>
      <table className="mx-auto border-collapse" aria-label={diagram?.description || 'Emoji diagram'}>
        <tbody>
          {grid.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td
                  key={cellIndex}
                  className="px-1.5 py-1 text-center align-middle whitespace-nowrap"
                  style={{ fontSize: cellFontSize }}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EmojiDiagramView;